import React, { useMemo } from 'react';
import { View, StyleSheet } from 'react-native';
import { useMarketplaceColors } from '@/constants/residents/marketplaceColors';

interface RadioButtonProps {
  isSelected: boolean;
  size?: 'small' | 'medium';
}

/**
 * Standalone radio button indicator component
 * Used in SoldFeedbackModal and ReportModal for option selection
 */
export const RadioButton: React.FC<RadioButtonProps> = ({
  isSelected,
  size = 'medium',
}) => {
  const mc = useMarketplaceColors();

  const styles = useMemo(() => StyleSheet.create({
    outer: {
      borderWidth: 1,
      borderColor: mc.checkboxBorder,
      backgroundColor: mc.checkboxBackground,
      alignItems: 'center',
      justifyContent: 'center',
    },
    outerSelected: {
      backgroundColor: mc.radioSelected,
      borderColor: mc.radioSelected,
    },
    inner: {
      backgroundColor: mc.radioInner,
    },
  }), [mc]);

  const containerSize = size === 'small' ? 14 : 16;
  const innerSize = size === 'small' ? 6 : 8;

  return (
    <View
      style={[
        styles.outer,
        {
          width: containerSize,
          height: containerSize,
          borderRadius: containerSize / 2,
        },
        isSelected && styles.outerSelected,
      ]}
    >
      {isSelected && (
        <View
          style={[
            styles.inner,
            {
              width: innerSize,
              height: innerSize,
              borderRadius: innerSize / 2,
            },
          ]}
        />
      )}
    </View>
  );
};
